import * as React from "react";
import LBox from "../LBox";
import LIcon from "../LIcon";
import LPressable from "../LPressable";
import { useLibrary } from "@hooks/trpc/useLibrary";
import AlbumButtons from "@components/Collection/AlbumButtons";
import PlaylistButtons from "@components/Collection/PlaylistButtons";
import { memo } from "react";
import { ICON_SIZE } from "@components/Collection/constants";
import DownloadButton from "@components/Collection/DownloadButton";
import { CollectionOptionsSWMSheet } from "@components/CollectionOptions";
import { useBottomSheetManager } from "react-native-bottom-sheet-stack";
import { theme } from "@theme";

type ButtonProps = {
  type: "album" | "playlist";
  isFetching: boolean;
  id: string;
  isOwner: boolean;
  isPublic: boolean;
};

const Buttons = ({ type, id, isOwner, isPublic }: ButtonProps) => {
  const { toggleCollectionLike, isLiked } = useLibrary();
  const bottomSheetManager = useBottomSheetManager();
  const liked = isLiked({ id: id, type });

  if (!id) return null;

  const showOptionsButton = !id.startsWith("liked_") && id !== "discover_daily";
  const canLikeDislikeCollection =
    !isOwner && !id.startsWith("liked_") && id !== "discover_daily";

  return (
    <LBox
      alignItems="center"
      flexDirection="row"
      justifyContent="space-between"
    >
      <LBox flexDirection="row" alignItems="center" gap="l1">
        <LPressable
          sentryEventName="toggle_collection_like"
          onPress={() => toggleCollectionLike(id, type)}
          disabled={!canLikeDislikeCollection}
          hitSlop={12}
        >
          <LIcon
            colors={{
              color: liked ? "#E6765A" : "whiteTranslucent50",
            }}
            name={liked ? "like_active" : "like_dormant"}
            enabled={canLikeDislikeCollection}
            size={ICON_SIZE}
          />
        </LPressable>
        <>
          <DownloadButton
            id={id}
            type={type}
            liked={liked}
            toggleCollectionLike={toggleCollectionLike}
          />
        </>
        {type === "album" && (
          <AlbumButtons id={id} type={type} iconSize={ICON_SIZE} />
        )}
        {type === "playlist" && (
          <PlaylistButtons
            id={id}
            type={type}
            iconSize={ICON_SIZE}
            isPublic={isPublic}
          />
        )}
      </LBox>

      {showOptionsButton ? (
        <LPressable
          onPress={() => {
            bottomSheetManager.open(
              <CollectionOptionsSWMSheet
                collectionId={id}
                collectionType={type}
              />,
              { mode: "push" },
            );
          }}
          sentryEventName="collection_options"
          style={{
            paddingLeft: theme.spacing.s3,
          }}
        >
          <LBox>
            <LIcon
              colors={{ color: "greyText" }}
              name="ellipsis"
              size={ICON_SIZE}
            />
          </LBox>
        </LPressable>
      ) : (
        <LBox
          height={ICON_SIZE}
          paddingHorizontal="s4"
          paddingVertical="s2"
          width={ICON_SIZE}
        />
      )}
    </LBox>
  );
};

export default memo(Buttons);
